import React from "react";
import { classNames } from "primereact/utils";
import "./AppDialog.scss";

export interface AppDialogFooterSecondaryAction {
    label: string;
    onClick: () => void;
    disabled?: boolean;
    icon?: string;
}

export interface AppDialogFooterProps {
    cancelLabel?: string;
    onCancel: () => void;
    cancelDisabled?: boolean;
    /** Optional actions immediately left of submit (outlined secondary). */
    secondaryActions?: AppDialogFooterSecondaryAction[];
    /** @deprecated Prefer secondaryActions. Kept for single-action callers. */
    secondaryLabel?: string;
    onSecondary?: () => void;
    secondaryDisabled?: boolean;
    secondaryIcon?: string;
    submitLabel: string;
    onSubmit: (event?: React.MouseEvent<HTMLButtonElement>) => void;
    submitDisabled?: boolean;
    submitLoading?: boolean;
    submitTitle?: string;
    submitType?: "button" | "submit";
    submitClassName?: string;
    className?: string;
}

const AppDialogFooter: React.FC<AppDialogFooterProps> = ({
    cancelLabel = "Annuleer",
    onCancel,
    cancelDisabled = false,
    secondaryActions,
    secondaryLabel,
    onSecondary,
    secondaryDisabled = false,
    secondaryIcon,
    submitLabel,
    onSubmit,
    submitDisabled = false,
    submitLoading = false,
    submitTitle,
    submitType = "button",
    submitClassName,
    className,
}) => {
    const resolvedSecondaryActions: AppDialogFooterSecondaryAction[] = secondaryActions?.length
        ? secondaryActions
        : (secondaryLabel && onSecondary
            ? [{
                label: secondaryLabel,
                onClick: onSecondary,
                disabled: secondaryDisabled,
                icon: secondaryIcon,
            }]
            : []);

    return (
        <div className={classNames("app-dialog-footer", className)}>
            <button
                type="button"
                className="app-dialog-footer__cancel"
                onClick={onCancel}
                disabled={cancelDisabled || submitLoading}
            >
                {cancelLabel}
            </button>
            <div className="app-dialog-footer__actions">
                {resolvedSecondaryActions.map((action) => (
                    <button
                        key={action.label}
                        type="button"
                        className="app-dialog-footer__secondary"
                        onClick={action.onClick}
                        disabled={Boolean(action.disabled) || submitLoading}
                    >
                        {action.icon ? <i className={action.icon} aria-hidden /> : null}
                        {action.label}
                    </button>
                ))}
                <button
                    type={submitType}
                    className={classNames("app-dialog-footer__submit", submitClassName, {
                        "is-loading": submitLoading,
                    })}
                    onClick={(event) => onSubmit(event)}
                    title={submitTitle}
                    disabled={submitDisabled || submitLoading}
                >
                    {submitLoading ? (
                        <i className="pi pi-spinner pi-spin" aria-hidden />
                    ) : null}
                    {submitLabel}
                </button>
            </div>
        </div>
    );
};

export default AppDialogFooter;
